import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { FC } from "react";

export const Logo: FC = () => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Stack spacing={2} alignItems="center" justifyContent="center">
        <CircularProgress color="primary" size={100} />
        <Typography variant="h6" color={fillColor}>
          Loading...
        </Typography>
      </Stack>
    </Box>
  );
};
